import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ListConfig } from './active-cases-list.interface';
import * as moment from 'moment';
import { AjaxService } from 'src/app/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { PatientCaseStatusColors } from 'src/app/landing/active-case/status.interface';

@Component({
  selector: 'app-active-cases-list',
  templateUrl: './active-cases-list.component.html',
  styleUrls: ['./active-cases-list.component.less']
})
export class ActiveCasesListComponent implements OnInit {

  _fieldsUIConfiguration: any;
  totalsColumns: number = 0;
  _datalist = [];
  totalRows = 0;
  navigationIndex = '0:0';
  selectedClinician: number[] = [];
  selectedConsultants: number[] = [];
  selectedPrimaryConsultant: number[] = [];
  _searchText: string = '';
  amount=0;
  showPaypalLinkDialog: boolean = false;
  showLink: boolean = false;
  paymentLink:string='';
  dataItem:any;
  @ViewChild('baseTemplate', { static: true })
  private baseTemplate!: TemplateRef<any>;
  @ViewChild('casePDFTemplate', { static: true })
  private casePDFTemplate!: TemplateRef<any>;
  @ViewChild('caseSummaryTemplate', { static: true })
  private caseSummaryTemplate!: TemplateRef<any>;
  @ViewChild('patientButtonTemplate', { static: true })
  private patientButtonTemplate!: TemplateRef<any>;
  @ViewChild('nameTemplate', { static: true })
  private nameTemplate!: TemplateRef<any>;
  @ViewChild('adminButtonTemplate', { static: true })
  private adminButtonTemplate!: TemplateRef<any>;
  @ViewChild('adminAmountPaidTemplate', { static: true })
  private adminAmountPaidTemplate!: TemplateRef<any>;
  @ViewChild('selectConsultant', { static: true })
  private selectConsultant!: TemplateRef<any>;
  @ViewChild('ageTemplate', { static: true })
  private ageTemplate!: TemplateRef<any>;
  @ViewChild('selectClinician', { static: true })
  private selectClinician!: TemplateRef<any>;
  @ViewChild('superAdminActionBtns', { static: true })
  private superAdminActionBtns!: TemplateRef<any>;
  @ViewChild('statusTemplate', { static: true })
  private statusTemplate!: TemplateRef<any>;
  @ViewChild('consultantButtonTemplate', { static: true })
  private consultantButtonTemplate!: TemplateRef<any>;
  @ViewChild('isPrimaryConsultant', { static: true })
  private isPrimaryConsultant!: TemplateRef<any>;
  @ViewChild('clinicianButtonTemplate', { static: true })
  private clinicianButtonTemplate!: TemplateRef<any>;
  @ViewChild('viewCaseFilesTemplate', { static: true })
  private viewCaseFilesTemplate!: TemplateRef<any>;


  private _listConfig: ListConfig | undefined;


  @Input()
  set fieldsUIConfiguration(val: any) {
    this._fieldsUIConfiguration = val;
  }

  get fieldsUIConfiguration(): any {
    return this._fieldsUIConfiguration;
  }

  constructor(private _ajaxService: AjaxService,
    private _confirmationService: ConfirmationService,
    private _translateService: TranslateService,
    private messageService: MessageService,
    private _dataService: CommonDataService) { }

  ngOnInit(): void {
  }

  isApprovedByApprover(data: any) {
    const key = 'IsApporovedByApporver' + this._dataService.approveLevel;
    return data.User[key];
  }

  get loggedInUserId() {
    return this._dataService?.userDetails?.data?.Id;
  }

  get role() {
    return this._dataService.role;
  }

  get searchText() {
    return this._searchText;
  }

  set searchText(text: string) {
    this._searchText = text;
  }

  get fieldsConfig(): any {
    return this._listConfig;
  }

  @Input()
  set fieldsConfig(val: any) {
    this._listConfig = { ...val };
    this.totalsColumns = (val && val.Columns) ? val.Columns.length : 0;
  }

  get datalist(): any {
    return this._datalist;
  }

  @Input()
  set datalist(val: any) {
    this._datalist = val || [];
    this.totalRows = this._datalist.length;
  }

  statusColor(dataItem: any) {
    const getKeyValue = <T extends object, U extends keyof T>(obj: T) => (key: U) =>
      obj[key];
    return getKeyValue(PatientCaseStatusColors)(dataItem.CurrentStatus);
  }

  disabledConsultant(consultantId: any) {
    if (this.selectedConsultants.length === 2 && this.selectedConsultants.indexOf(consultantId) == -1) {
      return true;
    }
    return false;
  }

  getAgeFromBirthDate(date: any) {
    if (!date || date === '') {
      return null;
    }
    return moment().diff(date, 'years');
  }

  getTemplate(template: any): TemplateRef<any> {

    switch (template) {
      case 'casePdf':
        return this.casePDFTemplate;
      case 'caseSummary':
        return this.caseSummaryTemplate;
      case 'patientBtns':
        return this.patientButtonTemplate;
      case 'name':
        return this.nameTemplate;
      case 'adminBtns':
        return this.adminButtonTemplate;
      case 'adminAmountPaid':
        return this.adminAmountPaidTemplate;
      case 'age':
        return this.ageTemplate;
      case 'selectConsultant':
        return this.selectConsultant;
      case 'selectClinician':
        return this.selectClinician;
      case 'superAdminActionBtns':
        return this.superAdminActionBtns;
      case 'status':
        return this.statusTemplate;
      case 'consultantButtonTemplate':
        return this.consultantButtonTemplate;
      case 'clinicianButtonTemplate':
        return this.clinicianButtonTemplate;
      case 'isPrimaryConsultant':
        return this.isPrimaryConsultant;
      case 'viewCaseFilesTemplate':
         return this.viewCaseFilesTemplate;
      default:
        return this.baseTemplate;
    }
  }

  getCellIndex(rowIndex: number, colIndex: number) {
    return rowIndex + ':' + colIndex;
  }

  editPCase(func1: any, data: any) {
    func1(data);
  }

  deletePCase(func1: any, data: any) {
    func1(data);
  }
  
  paymentStatus(func1: any, data: any) {
    func1(data);
  }

  payFeesPCase(func1: any, data: any) {
    func1(data);
  }
  viewCaseFiles(func1: any, data: any){
    func1(data);
    console.log("testing");
  }

  reasignConsultant(func1: any, dataItem: any){
    func1(dataItem);
  }

  addClinicianPCase(func1: any, dataItem: any) {
    func1(dataItem);
  }

  sendBackToPatient(func1: any, dataItem: any) {
    func1(dataItem);
  }

  sendToConsultant(func1: any, dataItem: any) {
    func1(dataItem);
  }

  addAdminNotes(func1: any, dataItem: any) {
    func1(dataItem);
  }

  addConultantMyNotes(func1: any, dataItem: any) {
    func1(dataItem);
  }

  checkConsultant(func1: any, event: any, dataItem: any) {
    const latest = this.selectedConsultants[this.selectedConsultants.length - 1];
    this.selectedConsultants = [];
    this.selectedConsultants.push(latest);
    func1(event, dataItem);
  }

  checkClinician(func1: any, event: any, dataItem: any) {
    const latest = this.selectedClinician[this.selectedClinician.length - 1];
    this.selectedClinician = [];
    this.selectedClinician.push(latest);
    func1(event, dataItem);
  }

  // getReviewPdf(data: any) {
  //   this._dataService.isLoading = true;
  //   this._ajaxService.post('/case/reviewCasePDf', { "CaseId": data.CaseId || data.Case.CaseId }, { responseType: 'blob' }).subscribe(result => {
  //     this._dataService.isLoading = false;
  //     window.open(window.URL.createObjectURL(result));
  //   },
  //     error => {
  //       this._dataService.isLoading = false;
  //     });
  // }
  getReviewPdf(data: any) {
    this._dataService.isLoading = true;
    this._ajaxService.post('/case/getCaseDocumentURL', { "CaseId": data.CaseId || data.Case.CaseId }).subscribe(result => {
      this._dataService.isLoading = false;
      if (result.data) {
        window.open(result.data);
      }
    },
      error => {
        this._dataService.isLoading = false;
      });
  }

  editUser(func: any, data: any) {
    func(data);
  }

  approveUser(func: any, data: any) {
    func(data);
  }

  deleteUser(func: any, data: any) {
    func(data);
  }

  disableSendToConsultantBtn(data: any) {
    return (data.CurrentStatus === 'Assigned') ? true : false;
  }

  acceptCase(func: any, data: any) {
    func(data);
  }

  rejectCase(func: any, data: any) {
    this._confirmationService.confirm({
      message: this._translateService.instant('LblRejectConfirmation'),
      rejectVisible: true,
      icon: 'pi pi-info-circle',
      accept: () => {
        //Actual logic to perform a confirmation
        func(data);
      },
      reject: () => {
      }
    });
  }

  needMoreInfo(func: any, data: any) {
    func(data);
  }

  audioRecord(func1: any, data: any) {
    func1(data);
  }

  sendToAdmin(func: any, data: any) {
    func(data);
  }

  primaryConsultant(func1: any, event: any, dataItem: any) {
    const latest = this.selectedPrimaryConsultant[this.selectedPrimaryConsultant.length - 1];
    this.selectedPrimaryConsultant = [];
    this.selectedPrimaryConsultant.push(latest);
    func1(event, dataItem);
  }

  addClinicianNotes(func: any, data: any) {
    func(data);
  }

  uploadFilePopup(func1: any, dataItem: any) {
    func1(dataItem);
  }

  isVirtualConsultation(func: any, dataItem: any) {
    func(dataItem);
  }

  getSummaryPdf(data: any) {
    this._dataService.isLoading = true;
    console.log(data);
    this._ajaxService.post('/case/getById',{"CaseId": data.CaseId || data.Case.CaseId}).subscribe(async(resp)=>{
      if(resp.data.CaseSummaryDocument==null){
      this._dataService.isLoading = false;
      return this.messageService.add({ severity: 'error', summary: 'Case Summary is not prepared yet'});
    }
     await this._ajaxService.post('/upload/getDocURL',{"CaseId": data.CaseId || data.Case.CaseId,"key":resp.data.CaseSummaryDocument.Key.toString()}).subscribe((response)=>{
      this._dataService.isLoading = false;
      window.open(response.data);
      },
        error => {
          this._dataService.isLoading = false;
        });
    })
    
    
    

    // this._ajaxService.post('/case/caseSummaryPDf', { "CaseId": data.CaseId || data.Case.CaseId }, { responseType: 'blob' }).subscribe(result => {
    //   this._dataService.isLoading = false;
    //   window.open(window.URL.createObjectURL(result));
    // },
    //   error => {
    //     this._dataService.isLoading = false;
    //   });
  }

  addCaseSummary(func1: any, dataItem: any) {
    func1(dataItem);
  }

}
